module.exports = __webpack_public_path__ + "img/footballBanner_320.f9ec47cf.png";